import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-associations',
  templateUrl: './associations.component.html',
  styleUrls: ['./associations.component.css']
})
export class AssociationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
